// src/hooks/useTrengo.js
import { useEffect, useState } from "react";

const useTrengo = () => {
  const [trengoLoaded, setTrengoLoaded] = useState(false);

  useEffect(() => {
    const checkTrengoInterval = setInterval(() => {
      if (window.Trengo && window.Trengo.Api && window.Trengo.Api.Widget) {
        console.log("Trengo widget API is beschikbaar.");
        setTrengoLoaded(true);
        clearInterval(checkTrengoInterval);
      } else {
        console.log("Wachten op beschikbaarheid van Trengo widget API...");
      }
    }, 500); // Controleer elke halve seconde

    return () => clearInterval(checkTrengoInterval); // Cleanup
  }, []);

  return trengoLoaded;
};

export default useTrengo;
